export function buildHeaders({ api, bearerKey, token }) {
  const headers = { 'Content-Type': 'application/json' };
  const keys = (api.headers || []).map(h => h.key);

  if (keys.includes('bearerkey') && bearerKey) {
    headers.bearerkey = bearerKey;
  }
  if (keys.includes('Authorization') && token) {
    headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
  }
  return headers;
}

export function buildRequest({ api, baseUrl, bearerKey, token, body }) {
  const url = `${(baseUrl || '').replace(/\/$/, '')}${api.endpoint}`;
  return {
    url,
    method: api.method || 'POST',
    headers: buildHeaders({ api, bearerKey, token }),
    body,
  };
}
